import Get from '../helpers/Get';

$(document).ready(function () {
    var width = $(window).width();
    var active = 0;
    const slider = $('.top-slider');
    const slides = $('.top-slider .slide_item');
    const slidesToShow = slides.length > 1 ? 1 : 1;
    // active = slides.length > 1 ? 1: 0;
    const centerMode = slides.length > 1;
    if (width < 992) {
        /*active = slides.length - 1;*/
    }
    if (Get.data['model']) {
        if (slider.find('[data-utm="' + Get.data['model'] + '"]').length) {
            active = slider.find('[data-utm="' + Get.data['model'] + '"]').index() + 1;
            if (width < 992) {
                active = slider.find('[data-utm="' + Get.data['model'] + '"]').index();
            }
        }
    }
    
    slider.slick({
        dots: true,
        slidesToScroll: 1,
        slidesToShow: slidesToShow,
        infinite: true,
        initialSlide: active,
        autoplay: true,
        autoplaySpeed: 7000,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    centerMode: false,
                    initialSlide: active
                }
            }
        ]
    });

    if ($(window).width() < 768) {
        $('.mobile-slider').slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            dots: false,
            infinite: false,
            initialSlide: active,
            prevArrow: '<div class="slick-arrow slick-arrow--prev"></div>',
            nextArrow: '<div class="slick-arrow slick-arrow--next"></div>',
        })
    }
});